import type { LucideProps } from "lucide-react";
import type { SiteIconKey } from "@/design-system/tokens/iconography";
import { getSiteIcon } from "./siteIconRegistry";

interface SiteIconProps extends LucideProps {
  name: SiteIconKey;
}

export const SiteIcon = ({ name, ...props }: SiteIconProps) => {
  const Icon = getSiteIcon(name);
  const { "aria-hidden": ariaHidden = true, ...iconProps } = props;

  return <Icon aria-hidden={ariaHidden} {...iconProps} />;
};
